import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";

import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

const initialState = {
  currentBalance: 0
};

const reducer = (state = initialState, action) => {
  let updatedObject = {};

  switch (action.type) {
    case ActionTypes.BALANCE_UPDATE:
      updatedObject = updateObject(state, {
        currentBalance: action.amountCents
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving BALANCE_UPDATE in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_BALANCE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    case ActionTypes.BALANCE_ADD_FUNDS:
      updatedObject = updateObject(state, {
        currentBalance: state.currentBalance + action.amountCents
      });

      if (action.shouldUpdateLocalStorage) {
        //pisi ga u local storage
        console.log("Saving BALANCE_ADD_FUNDS in local storage...");
        localStorage.setItem(
          LocalStorageKeys.LOCALSTORAGE_BALANCE,
          JSON.stringify(updatedObject)
        );
      }

      return updatedObject;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/BalanceReducer.js